import type { DayNightFlushingConfig } from "features/technical-data/scenario/model/types";

import { DEFAULT_REQUIRED_TEMPERATURES } from "features/technical-data/scenario/lib/scenarioDefaults";

export type { DayNightFlushingConfig };

export const REACTIVE_PARAMETERS = ["load", "room_air_temp"] as const;

export const TRY_FILES = [
  "TRY2015_Jahr",
  "TRY2015_Somm",
  "TRY2015_Wint",
  // "TRY2045_Jahr",
  // "TRY2045_Somm",
  // "TRY2045_Wint",
] as const;

export type ReactiveParameter = (typeof REACTIVE_PARAMETERS)[number];

export type ScenarioDefinitionFormState = {
  dayNightFlushing: DayNightFlushingConfig | null;
  detailed_simulation_needed: boolean;
  id: number;
  measured_weather_data: boolean;
  name: string;
  reactive_parameter: ReactiveParameter;
  requiredTMax: number;
  requiredTMin: number;
  t_supply_dynamic: boolean;
  try_file: TryFile;
  weather_data_year: number;
};

export type ScenarioDefinitionPayload = {
  dayNightFlushing: DayNightFlushingConfig | null;
  detailed_simulation_needed: boolean;
  measured_weather_data: boolean;
  reactive_parameter: ReactiveParameter;
  requiredTMax: number;
  requiredTMin: number;
  t_supply_dynamic: boolean;
  try_file: TryFile;
  weather_data_year: number;
};

export type TryFile = (typeof TRY_FILES)[number];

export const findTryFile = (value: unknown): TryFile | undefined => TRY_FILES.find((file) => file === value);

export const findReactiveParameter = (value: unknown): ReactiveParameter | undefined =>
  REACTIVE_PARAMETERS.find((parameter) => parameter === value);

export const createDefaultScenarioDefinition = (id: number, name: string): ScenarioDefinitionFormState => ({
  dayNightFlushing: null,
  detailed_simulation_needed: false,
  id,
  measured_weather_data: false,
  name,
  reactive_parameter: "load",
  requiredTMax: DEFAULT_REQUIRED_TEMPERATURES.requiredTMax,
  requiredTMin: DEFAULT_REQUIRED_TEMPERATURES.requiredTMin,
  t_supply_dynamic: false,
  try_file: "TRY2015_Jahr",
  weather_data_year: 2020,
});

export const buildScenarioDefinitionPayload = (scenario: ScenarioDefinitionFormState): ScenarioDefinitionPayload => ({
  dayNightFlushing: scenario.dayNightFlushing,
  detailed_simulation_needed: scenario.detailed_simulation_needed,
  measured_weather_data: scenario.measured_weather_data,
  reactive_parameter: scenario.reactive_parameter,
  requiredTMax: scenario.requiredTMax,
  requiredTMin: scenario.requiredTMin,
  t_supply_dynamic: scenario.t_supply_dynamic,
  try_file: scenario.try_file,
  weather_data_year: scenario.weather_data_year,
});
